import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { IntellioFormlyWrapperComponent } from './itc-formly-wrapper.component';
import { WrapperChangeDetectNotifierService } from './wrapper-change-detect-notifier.service';

import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'itc-formly-panel',
  styleUrls: ['./section.component.scss'],
  template: `
    <div class="section">
      <div class="section__form">
        <div class="section__title">{{ props.title }}@if (props?.icon === 'ai_generated') {
          <span class="section_chip section_chip_ai"><mat-icon inline class="section_chip_icon" fontSet="material-icons-outlined">auto_awesome</mat-icon>AI Generated</span>
        }</div>
        @if (props.description) {
          <div class="section_description">{{props.description}}</div>
        }
        <ng-container #fieldComponent></ng-container>
        <div></div>
      </div>
    </div>
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule]
})
export class SectionComponent
  extends IntellioFormlyWrapperComponent
  implements OnInit
{
  constructor(
    protected notifierService: WrapperChangeDetectNotifierService,
    protected cd: ChangeDetectorRef
  ) {
    super(notifierService, cd);
  }

  ngOnInit() {
    this.initChangeDetectSub();
  }
}
